var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-block btn-success no-border payment-btn",class:{ 'is-loading': _vm.sendBalanceTransactionLoading },attrs:{"type":"button"},on:{"click":_vm.pay}},[_vm._v(" "+_vm._s(_vm.payButtonText())+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }